import { defineComponent as d, useAttrs as u, computed as p, unref as t, openBlock as i, createElementBlock as l, mergeProps as n } from "vue";
import { DividerOrientations as a, getDividerClasses as m } from "./novoui-vuejs75.js";
const y = /* @__PURE__ */ d({
  inheritAttrs: !1,
  __name: "NDivider",
  props: {
    orientation: { default: a.horizontal },
    color: { default: void 0 }
  },
  setup(c) {
    const { class: o, ...r } = u(), e = c, s = p(() => m(e.orientation));
    return (f, v) => e.orientation === t(a).horizontal ? (i(), l("hr", n({ key: 0 }, r, {
      class: [s.value, t(o)],
      style: { borderColor: e.color }
    }), null, 16)) : (i(), l("div", n({
      key: 1,
      class: "divider"
    }, r, {
      class: [s.value, t(o)],
      style: { color: e.color }
    }), null, 16));
  }
});
export {
  y as default
};
